export default "__VITE_PUBLIC_ASSET__ef51ed75__"